<template>
  <MainLayout>
    <Head title="Dashboard" />
    <template v-slot:header>
      Dashboard
    </template>

    <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div v-for="card in cards" :key="card.name" class="bg-white overflow-hidden shadow rounded-lg">
        <div class="p-5">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <component :is="card.icon" class="h-6 w-6 text-gray-400" aria-hidden="true" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt class="text-sm font-medium text-gray-500 truncate">
                {{ card.name }}
                </dt>
                <dd>
                <div class="text-lg font-medium text-gray-900">
                  {{ card.amount }}
                </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import {
  DatabaseIcon,
  LightBulbIcon,
  TruckIcon,
  CogIcon,
  ShoppingCartIcon,
} from '@heroicons/vue/outline'
import MainLayout from '../layouts/main.vue'

export default {
  components: {
    MainLayout,
    DatabaseIcon,
    LightBulbIcon,
    TruckIcon,
    CogIcon,
    ShoppingCartIcon,
    Head,
  },

  props: {
    cards: Array,
  }
}
</script>
